export default {"src":"/_next/static/media/ic-silver-cup.263c9dce.svg","height":128,"width":128};